import { axiosInstance } from "../authService";
import ApiUrlConstant from "../Constants";
import { apiKey } from "../../config/env";
const headers = { "Ocp-Apim-Subscription-Key": apiKey };

const authService = {
  login: (data) => {
    return axiosInstance.post(ApiUrlConstant.loginService(), data, {
      headers,
    });
  },
  logout: (token) => {
    return axiosInstance.post(
      ApiUrlConstant.logoutService(),
      { source: "web" },
      {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },
  profile: () => {
    return axiosInstance.get(ApiUrlConstant.profileService(), null, {headers});
  },
  forgotPassword: (data) => {
    return axiosInstance.post(ApiUrlConstant.forgotPasswordService(), data,{headers});
  },
  resetPassword: (data) => {
    return axiosInstance.post(ApiUrlConstant.resetPasswordService(), data,{headers});
  },
  createPassword: (data)=>{
    return axiosInstance.post(ApiUrlConstant.createPasswordService(), data,{headers});
  },
  verifyToken:(data)=>{
    return axiosInstance.post(ApiUrlConstant.verifyTokenService(), data,{headers});
  }
 
};

export default authService;

/* 
Send data as per query params example 
return axiosInstance.post(ApiUrlConstant.loginService(), null, { params: data });


https://api.example.com/login?username=john_doe&password=12345
*/
